import { Link } from 'react-router-dom'
import { useFormSchema } from '@/features/admin/forms/hooks'
import { DualListPicker } from '@/components/common/DualListPicker'
import { useSetConfigurationSections } from '../hooks'

export function SectionsPanel({ configurationCode }: { configurationCode: string }) {
  const allQ = useFormSchema('contract')
  const productQ = useFormSchema(`configuration/${configurationCode}`)
  const setSections = useSetConfigurationSections(configurationCode)

  if (allQ.isLoading) return <div>Ładowanie sekcji...</div>
  if (!allQ.data) return null

  const all = allQ.data.sections
  const selected = productQ.data?.sections ?? []
  const selectedIds = new Set(selected.map(s => s.id))
  const available = all.filter(s => !selectedIds.has(s.id))

  return (
    <div className="flex flex-col gap-3 text-sm">
      <p className="text-xs text-slate-500">
        Przeciągnij sekcje, które ma zawierać ten produkt z lewego panelu na prawy. Kolejność na prawym panelu = kolejność wyświetlania.
        Sekcje są współdzielone - definiujesz je raz w{' '}
        <Link to="/settings/forms/contract" className="text-sky-700 underline">Formularze</Link>.
      </p>

      <DualListPicker
        available={available}
        selected={selected}
        getId={s => s.id}
        renderItem={s => (
          <div className="flex items-baseline gap-2">
            <span>{s.labelPl}</span>
            <span className="font-mono text-[10px] text-slate-400">{s.code}</span>
          </div>
        )}
        onChange={ids => setSections.mutate(ids.map(Number))}
        availableLabel="Dostępne sekcje"
        selectedLabel="Aktywne w tym produkcie"
        emptyAvailable={
          all.length === 0 ? (
            <span>
              Brak globalnych sekcji - dodaj w{' '}
              <Link to="/settings/forms/contract" className="text-sky-700 underline">Formularze</Link>.
            </span>
          ) : (
            <span>Wszystkie sekcje są podpięte</span>
          )
        }
        emptySelected={<span>Przeciągnij sekcje tutaj</span>}
      />
    </div>
  )
}
